import logo from './ldd-logo-icon.jpg';
import './footer.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import React from 'react';
import { useAppSelector } from '../../redux/hooks';
import { lddGlobalSessionInfo } from '../navigationTypes';

const Footer = (props) => {
    const SESSION_INFO: lddGlobalSessionInfo = useAppSelector((g) => g.SessionInfo);
    return (
        <div className="footer-container">
            <OverlayTrigger placement="top" delay={200} overlay={
                    <Tooltip>Powered by LawyerDoneDeal</Tooltip>
                }>
                <a href="https://www.ldd.ca/" className="footer-tab ldd" target="_blank" rel="noopener" title="LDD Website">
                    <img src={logo} alt="LDD Logo" />
                </a>
            </OverlayTrigger>

            <OverlayTrigger placement="top" delay={200} overlay={
                    <Tooltip>Help & Support</Tooltip>
                }>
                    <div className="footer-tab support" onClick={() => {
                        let cookie = `BrowserSessionID=${SESSION_INFO.sid};`;
                        cookie += `domain=.${window.location.hostname.split('.').slice(-2).join('.')};`;
                        cookie += "path=/";
                        document.cookie = cookie;
                        window.open("https://lawyerdonedeal.zohodesk.com/portal/en/kb/ldd", "_blank");
                    }}>
                <i className="fa-duotone fa-life-ring"></i>
            </div>
            </OverlayTrigger>
        </div>
    );
}

export default Footer;